var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{},[_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_c('b-row',[_c('b-col',[_c('h5',{staticClass:"more_ttl"},[_vm._v(_vm._s(_vm.infomation[_vm.param.infomation].title))]),_c('div',{staticClass:"content-details",domProps:{"innerHTML":_vm._s(_vm.infomation[_vm.param.infomation].value)}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }